require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-reimaginingtheworkplace.json") })
        }
      }, "path---insights-reimaginingtheworkplace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-reimaginingtheworkplace!./.cache/json/insights-reimaginingtheworkplace.json
// module id = 1132
// module chunks = 231608221292675